import { HbrSpinner } from '@harbor/elements-react-standalone';
import React from 'react';

interface StbLoaderProps {
  isLoading: boolean;
}

const StbLoader: React.FC<StbLoaderProps> = ({
  isLoading = false,
}) => {
  return (
    <>
      { isLoading
        ? (
          <>
            <div
              className='z-[51] fixed top-0 left-0 w-[100vw] h-[100vh]'
            ></div>
            <section
              className={`bg-white z-[52] fixed top-1/2 left-1/2 w-64 min-w-64 rounded-md -translate-x-1/2 -translate-y-1/2 border border-gray-200 shadow-lg`}
            >
              <div className='px-6 py-8 flex justify-center'>
                <HbrSpinner size='medium' />
              </div>
            </section>
          </>
        )
        : null
      }
    </>
  );
};

export default StbLoader;
